var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "d-flex flex-column screen-control-planning-table__schedule-cell",
    },
    [
      _c("kh-text", {
        staticClass: "flex-grow-1",
        attrs: { text: _vm.startOperation },
      }),
      _vm._v(" "),
      _c("kh-text", {
        staticClass: "flex-grow-1",
        attrs: { text: _vm.endOperation },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }